import React from 'react'

import { Spinner } from './styles'

import loader from 'images/loader.svg'

const Loader = () => <Spinner src={loader} alt='Loader Spinner Image' />

export default Loader
